import { Grid } from "@mui/material";
import { PlanCard } from "./PlanCard";
import { useTranslation } from "react-i18next";

export function UpgradePage() {
  const { t } = useTranslation(["common", "upgrade", "plan"]);
  return (
    <Grid container spacing={2} className="slide-from-bottom">
      <Grid item xs={1}></Grid>
      <Grid item xs={2.25} className="slide-from-bottom">
        <PlanCard
          name={t("plan:NEWS+")}
          content={[
            t("plan:Only_need_to_register"),
            t("plan:Real_time_news_data"),
          ]}
          planID={1}
          price={t("plan:FREE")}
        />
      </Grid>
      <Grid item xs={0.5}></Grid>
      <Grid item xs={2.25} className="slide-from-bottom">
        <PlanCard
          name={t("plan:FORUM+")}
          content={[
            t("plan:All_news_features"),
            t("plan:Real_time_forums_data"),
            t("plan:5_detailed_reports_daily"),
          ]}
          planID={1}
          price={"199.000đ " + t("plan:monthly")}
          color={"#59DF67"}
        />
      </Grid>
      <Grid item xs={0.5}></Grid>
      <Grid item xs={2.25} className="slide-from-bottom">
        <PlanCard
          name={t("plan:SOCIAL_MEDIA+")}
          content={[
            t("plan:All_news_forums_features"),
            t("plan:Real_time_social_data"),
            t("plan:10_detailed_reports_daily"),
          ]}
          planID={1}
          price={"599.000đ " + t("plan:monthly")}
          color={"#e57373"}
        />
      </Grid>
      <Grid item xs={0.5}></Grid>
      <Grid item xs={2.25}>
        <PlanCard
          name={t("plan:ENTERPRISE")}
          content={[
            t("plan:All_news_forums_social_features"),
            t("plan:Real_time_dashboards"),
            t("plan:100_detailed_reports_daily"),
            t("plan:Real_time_notis_via_email_sms"),
          ]}
          planID={1}
          price={"3.999.000đ " + t("plan:monthly")}
          color={"#fdd835"}
        />
      </Grid>
      <Grid item xs={2.5}></Grid>
    </Grid>
  );
}
